














import { Component, Vue } from "vue-property-decorator";
import { getExtensionInfo } from "@/services/customExtensions/customExtensionService";
import { CustomExtension } from "@/services/customExtensions/types";
import moment from "moment";

@Component
export default class CustomExtensionInfoModal extends Vue {
    customExtensionInfo = {} as CustomExtension;

    open(customExtensionId: string) {
        getExtensionInfo(customExtensionId).then(response => {
            this.customExtensionInfo = response;
            this.$bvModal.show("modal-customExtensionInfo");
        });
    }

    hide() {
        this.$bvModal.hide("modal-customExtensionInfo");
    }
}
